const aboutData = [
    {
        id: "1",
        icon: require("../../assets/icons/forensic.svg").default,
        title: "Forensic Accounting Services",
        text: "We resolve disputes by combining accounting expertise and investigative skills to deliver effective forensic accounting solutions."
    },
    {
        id: "1",
        icon: require("../../assets/icons/stash_target-light.svg").default,
        title: "Audit and Assurance Services",
        text: "We improve your financial reporting and provide assurance through tailored audits for effective business operations and compliance."
    },
    {
        id: "1",
        icon: require("../../assets/icons/streamline_bag-dollar (1).svg").default,
        title: "Business Advisory and Consulting Services",
        text: "We help businesses adapt, grow, and succeed with expert advisory on restructuring, valuations, audits, and management consulting."
    },
]

export default aboutData;